import watchNewFilterUsuarioProdutor from './saga/newFilter';
import watchNewFilterNextPageUsuarioProdutor from './saga/newFilterNextPage';
import watchFindSagas from './saga/find';

export const usuarioProdutorSaga = [
  watchNewFilterUsuarioProdutor(),
  watchNewFilterNextPageUsuarioProdutor(),
  watchFindSagas(),
];

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';